import css from "./Form.scss";
import React, { useEffect, useState } from "react";
import StyledButton from "../common/StyledButton";
import TermDropdown from "./TermDropdown"
import ServiceDropdown from "./ServiceDropdown"
import PropTypes from "prop-types";
import DateRange from "./DateRange";
import FileFormat from "./FileFormat";
import useStarfishAPI from "hooks/useStarfishAPI";
import { reportEnqueuedEvent } from "../utils/events";
import { NotificationCenter } from 'utils/types';
import { isFormValid, parseScheduleBlockReportRequest } from "../utils/scheduleBlockReport";

const Form = props => {

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedFileFormat, setSelectedFileFormat] = useState("xls");
  const [selectedTerm, setSelectedTerm] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [submitResponse, callAPI] = useStarfishAPI();

  const onSubmit = () => {
    let validator = isFormValid(startDate, endDate, selectedService);
    if (!validator.validForm) {
      props.setToastMessage(validator.errorMessage);
      props.setToastTimeout(10000);
      return;
    }

    callAPI(`scheduleBlockReport.html`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(
        parseScheduleBlockReportRequest(selectedTerm,
          startDate,
          endDate,
          selectedService,
          selectedFileFormat)
      )
    }, false)
  };

  useEffect(() => {
    if (submitResponse.success) {
      props.setToastMessage("Your report request has been added to the queue.");
      props.setToastTimeout(5000);
      props.notificationCenter.fireEvent(reportEnqueuedEvent);
    }
  }, [submitResponse]);

  useEffect(() => {
    if (submitResponse.error) {
      props.setToastMessage(submitResponse.error);
      props.setToastTimeout(5000);
    }
  }, [submitResponse]);

  return (
    <div className={css["container"]}>
      <h3 className={"sf-admin-title"}>Schedule Block Report</h3>
      <div className={css['report-instructions']}>
        The Schedule Block Report runs by service and exports service members’ calendar details, including block
        start/end times and duration. For each service member, the report contains office hours, ad hoc appointments
        (appointments outside of office hour blocks), group sessions, reserve time, and external calendar blocks.
        Additionally, if a service member belongs to more than one service, all office hours and group sessions display
        across all services.
        <div className={css["instruction-note"]}>
          Note: The Excel format has a limit of 65,500 rows per tab, which may result in missing data for services that
          have a lot of service members. Consider using the CSV format for large amounts of data.
        </div>
      </div>
      <div className={css['report-container']}>

        <div className={css['filters']}>
          <div className={css['required-filters']}>
            <h1>Required Filters</h1>
            <TermDropdown
              terms={props.terms}
              setSelectedTerm={setSelectedTerm}
              selectedTerm={selectedTerm ? selectedTerm : null}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
            />
            <DateRange
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              setSelectedTerm={setSelectedTerm}
            />
            <ServiceDropdown
              services={props.services}
              setSelectedService={setSelectedService}
              selectedService={selectedService}
            />
          </div>
          <FileFormat
            selectedFileFormat={selectedFileFormat}
            setSelectedFileFormat={setSelectedFileFormat}
          />
        </div>

        <div className={css['generate-report']}>
          <StyledButton
            className={css['generate-button']}
            onClick={() => onSubmit()}>
            Generate Report
          </StyledButton>
        </div>
      </div>
    </div>
  );
};

Form.propTypes = {
  terms: PropTypes.array.isRequired,
  services: PropTypes.array.isRequired,
  notificationCenter: NotificationCenter.isRequired,
  setToastTimeout: PropTypes.func.isRequired,
  setToastMessage: PropTypes.func.isRequired
};

export default Form;
